import { useHelper } from "@react-three/drei";
import { useEffect, useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { RectAreaLightUniformsLib } from "three/examples/jsm/lights/RectAreaLightUniformsLib.js";
import { addEventListener } from "../src/events/eventBus";

export default function Lights() {
  const directionalLightRef = useRef();
  const hallAreaLightRef = useRef();
  const cakeLightRef = useRef();
  const cakeLightTargetIntensity = useRef(0);

  useEffect(() => {
    RectAreaLightUniformsLib.init();
  }, []);

  useEffect(() => {
    const unsubscribePlay = addEventListener("playCake", () => {
      cakeLightTargetIntensity.current = 2;
    });

    return () => {
      unsubscribePlay();
    };
  }, []);

  useFrame((_, delta) => {
    const light = cakeLightRef.current;
    if (!light) return;

    const current = light.intensity;
    const target = cakeLightTargetIntensity.current;
    if (Math.abs(current - target) < 0.01) {
      light.intensity = target;
      return;
    }

    const lerpFactor = 1 - Math.exp(-8 * delta);
    light.intensity = THREE.MathUtils.lerp(current, target, lerpFactor);
  });

  // useHelper(directionalLightRef, THREE.DirectionalLightHelper, 1);

  return (
    <>
      <directionalLight
        castShadow
        shadow-normalBias={.5}
        position={[20, 30, 10]}
        intensity={5}
        shadow-mapSize={[1024, 1024]}
        shadow-camera-near={1}
        shadow-camera-far={250}
        shadow-camera-top={250}
        shadow-camera-right={250}
        shadow-camera-bottom={-250}
        shadow-camera-left={-250}
        name="followLight"
        ref={directionalLightRef}
      />
      <rectAreaLight
        args={["#ffffff", 2, 10, 80]}
        position={[7.8, 20, -101]}
        rotation={[-Math.PI / 2, 0, 0]}
        ref={hallAreaLightRef}
      />
      <rectAreaLight
        args={["#ffffff", 0, 30, 15]}
        position={[2.59, 9.485, 50.1]}
        rotation={[-Math.PI / 2, 0, 0]}
        ref={cakeLightRef}
        idElement='cakeLight'
      />
      <rectAreaLight
        args={["#ffffff", 5, 10, 5]}
        position={[60.8, 8.76, -14.41]}
        rotation={[-Math.PI / 2, 0, 0]}
        ref={hallAreaLightRef}
      />
      <ambientLight intensity={2} />
    </>
  );
}
